// Thomas Age verification 6/19/2023
//Functions to get, set and erase cookie
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

//Check for Age
function verifyAge() {
  setCookie('mbav', 'true',60);
  verified();
  closeModal();
}

//Apply age verification buttons and disable image as a link
function applyBtns() {
    //recommended and previously viewed images
    var tempArr = [...document.querySelectorAll('.productitem--image-primary.mb-blur')];
    var avBtnContainers = [];
    //primary product page gallery
    if (document.body.contains(document.querySelector('.product-gallery--image-background.mb-blur'))){
      var avBtnContainers = [document.querySelector('.product-gallery--navigation')];
    }
    tempArr.forEach(elm => {
      elm.closest('.productitem--image-link').setAttribute('onclick', 'return false;');
      //elm.closest('.productitem--image-link').setAttribute('href', 'javascript:void(0)');
      avBtnContainers.push(elm.parentElement);
    });
    //apply buttons
    avBtnContainers.forEach(elm => {
      const button = document.createElement('button')
      button.innerText = 'Age Verification';
      button.setAttribute("class", "av-btn");
      button.setAttribute('type', 'button');
      button.addEventListener('click', () => {
        $('.popup-wrap').fadeIn(200);   
      })
      if (elm.classList.contains('product-gallery--navigation' || elm.hasAttribute("data-splide"))){
        elm.parentElement.appendChild(button);
      } else {
        elm.appendChild(button);
      }
      //hoverable av buttons on viewports larger than tablet
      function hoverBtns() {
        elm.addEventListener('mouseover', () => {
          if(window.innerWidth > 600){
            var buttons = elm.parentElement.querySelectorAll('.av-btn');
            for (let button of buttons) {
                button.style = "display:block";
            }
          }
        });
        elm.addEventListener('mouseleave', () => {
        if(window.innerWidth > 600){
            var buttons = elm.parentElement.querySelectorAll('.av-btn');
            for (let button of buttons) {
                button.style = "display:none";
            }
          }
        });
      }
      if (elm.classList.contains('product-gallery--navigation')){
        elm = elm.parentElement;
        hoverBtns();
      } else {
        hoverBtns();
      }
    });
}

//Age has been verified, remove buttons, remove blurred styling from images and enable images as a link
function verified() {
  var blurTargets = [...document.querySelectorAll('.mb-blur')];
  if (document.body.contains(document.querySelector('.mb-blur--zoom-disabled'))) {
    document.querySelectorAll('.mb-blur--zoom-disabled').forEach(elm => {
      elm.classList.remove('mb-blur--zoom-disabled');
    });
  }
  var avBtnTargets = [...document.querySelectorAll('.av-btn')];
  var clickableTargets = [...document.querySelectorAll('[onclick="return false;"]')];
  avBtnTargets.forEach(elm => {
    elm.remove('mb-blur--zoom-disabled', 'mb-blur');
  });
  blurTargets.forEach(elm => {
    elm.classList.remove('mb-blur--zoom-disabled', 'mb-blur');
  });
  setTimeout(() => {
    clickableTargets.forEach(elm => {
      elm.removeAttribute("onclick");
    });
  }, "1000");
} 

//Modal code
function closeModal() {
  $('.popup-wrap').fadeOut(200);
}
//console.log('~~~~~~~~1/14/2025')
// Thomas Age verification 6/19/2023